import { useDispatch } from 'react-redux';
import { addNotification } from '../actions';

export const useAddNotification = () => {
  const dispatch = useDispatch();

  return ({ type = 'info', message = '', direction = 'bottomCenter', ...rest }) =>
    dispatch(
      addNotification({
        id: `${type}-${Date.now()}`,
        message,
        type,
        direction,
        ...rest,
      }),
    );
};

export default useAddNotification;
